import React from 'react';

import { ApplicationWrapper, AuthType } from '@innovyze/stylovyze';
import { miniPageRoutes } from '@Pages';

function App() {
  const pages = miniPageRoutes;

  return (
    <ApplicationWrapper
      pages={pages}
      loginPicker={AuthType.Forge}></ApplicationWrapper>
  );
}

export default App;
